import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

let initMeta = {
  auth: false,
  title: 'Semua Event seminar webinar kampus Indonesia - Eventversity',
  AppBarNav: 'default',
  BottomNav: true,
  nextUrl: null,
};

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Eventversity',
    }),
  },
  {
    path: '/create-event',
    name: 'CreateEvent',
    component: () => import('../views/CreateEvent.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Homepage',
    }),
  },
  {
    path: '/my-ticket',
    name: 'MyTicket',
    component: () => import('../views/MyTicket.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'My Ticket',
      auth: true,
    }),
  },
  {
    path: '/my-ticket/scan/:transaction_id',
    name: 'MyTicketScan',
    component: () => import('../views/MyTicketScan.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Scan Tiket',
      auth: true,
      AppBarNav: 'back',
      BottomNav: false,
    }),
  },
  {
    path: '/my-ticket/:transaction_id',
    name: 'MyTicketDetail',
    component: () => import('../views/MyTicketDetail.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Tiket Saya',
      auth: true,
      AppBarNav: 'back',
      BottomNav: false,
    }),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Homepage',
      auth: true,
    }),
  },
  {
    path: '/my-account',
    name: 'MyAccount',
    component: () => import('../views/MyAccount.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'My Account',
      auth: true,
    }),
  },
  {
    path: '/my-account/edit',
    name: 'MyAccountEdit',
    component: () => import('../views/MyAccountEdit.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Edit Account',
      auth: true,
    }),
  },
  {
    path: '/semua-event',
    name: 'Explore',
    component: () => import('../views/Explore.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Explore',
    }),
  },
  {
    path: '/semua-event/:slug',
    name: 'CategoryEvent',
    component: () => import('../views/ExploreCategory.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Category',
    }),
  },
  {
    path: '/event/:id/:slug',
    name: 'EventDetail',
    component: () => import('../views/EventDetail.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Detail',
      AppBarNav: 'back',
      BottomNav: false,
    }),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: Object.assign({}, initMeta, {
      title: '',
      AppBarNav: null,
      BottomNav: false,
    }),
  },
  {
    path: '/checkout/:ticket_id',
    name: 'Checkout',
    component: () => import('../views/Checkout.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Checkout',
      auth: true,
      AppBarNav: 'back',
      BottomNav: false,
    }),
  },
  {
    path: '/checkout/:ticket_id/payment',
    name: 'CheckoutPayment',
    component: () => import('../views/CheckoutPayment.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Payment',
      auth: true,
      AppBarNav: 'back',
      BottomNav: false,
    }),
  },
  {
    path: '/checkout-complete',
    name: 'CheckoutSuccess',
    component: () => import('../views/CheckoutSuccess.vue'),
    meta: Object.assign({}, initMeta, {
      title: '',
      auth: true,
      BottomNav: false,
    }),
  },
  {
    path: '/bantuan',
    name: 'Faq',
    component: () => import('../views/Faq.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Bantuan',
      BottomNav: false,
      AppBarNav: 'back',
    }),
  },
  {
    path: '/article',
    name: 'Article',
    component: () => import('../views/Article.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Bacaan dan informasi seputar event dan kehidupan kampus',
      BottomNav: false,
    }),
  },
  {
    path: '/article/:id/:slug',
    name: 'ArticleDetail',
    component: () => import('../views/ArticleDetail.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Detail',
      AppBarNav: 'back',
      BottomNav: false,
    }),
  },
  {
    path: '/cari-event',
    name: 'Search',
    component: () => import('../views/Search.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Cari Event',
      AppBarNav: null,
      BottomNav: false,
    }),
  },
  {
    path: '*',
    redirect: '/not-found',
  },
  {
    path: '/not-found',
    name: 'NotFound',
    component: () => import('../views/Error404.vue'),
    meta: Object.assign({}, initMeta, {
      title: 'Halaman tidak ditemukan',
      AppBarNav: null,
      BottomNav: false,
    }),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.auth)) {
    if (localStorage.getItem('token') == null) {
      next({
        path: '/login',
        query: { ref: to.path },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
